<template>
  <div id="exhibitionProject">
    <div class="title"><span>品牌展会</span></div>
    <el-carousel indicator-position="outside" ref="myCarousel" id="myCarousel">
      <el-carousel-item v-for="item in list" :key="item.project_id">
        <div class="project-list">
          <div class="project-item">
            <img :src="item[0].thumbnail_path" />
            <span>{{ item[0].title }}</span>
          </div>
          <div class="project-item">
            <img :src="item[1].thumbnail_path" />
            <span>{{ item[1].title }}</span>
          </div>
          <div class="project-item">
            <img :src="item[2].thumbnail_path" />
            <span>{{ item[2].title }}</span>
          </div>
          <div class="project-item">
            <img :src="item[3].thumbnail_path" />
            <span>{{ item[3].title }}</span>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import * as api from "../../core/api";

export default {
  data() {
    return {
      list: [],
    };
  },
  async created() {
    const res = await api.get("/api/project", { page: 1, limit: 99999 });
    if (res.data) {
      const len = Math.ceil(res.data.length / 4);
      for (let i = 0; i < len; i++) {
        const list = res.data.splice(0, 4);
        this.list.push(
          list.map((item) => {
            const thumbnail_path = item.thumbnail_path.replace("http", "https");
            return { ...item, thumbnail_path };
          })
        );
      }
      console.log(this.list);
    }
  },
  mounted() {
    const myCarousel = document.getElementById("myCarousel");
    myCarousel.addEventListener("touchstart", (e) => {
      this.thetouchstart(e);
    });

    myCarousel.addEventListener("touchend", (e) => {
      this.thetouchend(e);
    });
  },
  methods: {
    thetouchstart(e) {
      this.theTouch = e.touches[0].pageX; //保存开始滑动的点
    },
    thetouchend(e) {
      if (e.changedTouches[0].pageX > this.theTouch) {
        //判断手指是向左还是向右滑动
        this.$refs.myCarousel.prev();
      } else {
        this.$refs.myCarousel.next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#exhibitionProject {
  padding: 16px;
  background: #f6f9ff;
  .title {
    display: flex;
    align-items: center;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #0068b7;
    position: relative;
    margin-bottom: 50px;
    span {
      position: absolute;
      z-index: 2;
    }
  }
  .title::after {
    content: "EXHIBITION";
    position: absolute;
    font-weight: bold;
    font-size: 18px;
    color: #efefef;
    top: 1px;
    z-index: 1;
  }
  .title::before {
    content: "";
    width: 86px;
    height: 3px;
    background: #0068b7;
    position: absolute;
    top: 24px;
  }
  /deep/.el-carousel__container {
    height: 394px;
  }

  /deep/.el-carousel__arrow {
    display: none;
  }
  /deep/.el-carousel__button {
    width: 6px;
    height: 6px;
    background: #605e5e;
    border-radius: 100%;
  }
  /deep/.el-carousel__indicator.is-active button {
    background: #0068b7;
    border-radius: 33px 33px 33px 33px;
    width: 23px;
    height: 6px;
  }
  .titles {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .project-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .project-item {
    width: 164px;
    display: flex;
    flex-direction: column;
    img {
      width: 164px;
      height: 120px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
    }
    span {
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      margin: 14px 0;
    }
  }
}
</style>